const apiUrl = process.env.API_URL || "https://api.cannamart.ca/mock";
const supplierApiUrl = "https://i2awjozkg6.execute-api.ca-central-1.amazonaws.com/mock";

export { apiUrl, supplierApiUrl };